import React from 'react';
import { Typography } from '../design-system/typography';
import { colors, spacing } from '../design-system/tokens';

interface NotesSectionProps {
  notes: Array<{
    label: string;
    content: string;
  }>;
  className?: string;
}

export const NotesSection: React.FC<NotesSectionProps> = ({ 
  notes,
  className = '' 
}) => {
  if (!notes.length) return null;

  return (
    <div 
      className={className}
      style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: spacing.figma.sectionGap 
      }}
    >
      {notes.map((note, index) => (
        <div key={index} style={{ minWidth: 0 }}>
          <Typography 
            variant="ledgerLabel" 
            as="div"
            style={{ 
              color: colors.text.primary, 
              textTransform: 'uppercase',
              marginBottom: spacing.xs
            }}
          >
            {note.label}
          </Typography>
          <Typography 
            variant="valueAddress" 
            as="div"
            style={{ 
              color: colors.text.primary,
              wordWrap: 'break-word',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap'
            }}
          >
            {note.content}
          </Typography>
        </div>
      ))}
    </div>
  );
};